module.exports = __webpack_public_path__ + "static/media/desktop-b@3x.7c568367.png";